import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbField } from "abreact/form/AbField";
import * as AbFormHooks from "abreact/form/AbFormHooks";
import { AbColorDataValueInput } from "abreact/input/AbColorDataValueInput";
import * as React from "react";
export function AbColorField(props) {
  const viewModel = AbFormHooks.useDataValueFieldViewModel("ab-color-data-value-input", props);
  if (!viewModel) {
    return null;
  }
  return /*#__PURE__*/React.createElement(AbField, _extends({}, viewModel.fieldProps, {
    fullWidth: viewModel.isEditing
  }), /*#__PURE__*/React.createElement(AbColorDataValueInput, viewModel.inputProps));
}
//# sourceMappingURL=AbColorField.js.map
